import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable, concatMap } from 'rxjs'
import { dataCyclesReducer } from '@containers/data-cycles/data-cycles.reducers'

@Injectable()
export class CompoundsService {
  constructor(private http: HttpClient) {}

  public fetchCompounds(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/compound/list`
    return this.http.post(url, params)
  }

  public fetchCompound(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/compound/${id}`
    return this.http.get(url, {})
  }

  public updateCompound(id: number, payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/compound/${id}`
    return this.http.put(url, payload)
  }

  public createCompound(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/compound`
    return this.http.post(url, payload)
  }

  public fetchCompoundPayments(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/compound/${id}/financial`
    return this.http.get(url, {})
  }

  public createCompoundPayment({
    payableId,
    ...payload
  }: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/payment/${payableId}`
    return this.http
      .post(url, payload)
      .pipe(
        concatMap(() =>
          this.http.get(
            `${environment.API_ENDPOINT}/payment/payable/${payableId}`,
          ),
        ),
      )
  }

  public updateCompoundPayment({
    id,
    payableId,
    ...payload
  }: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/payment/${id}`
    return this.http
      .put(url, payload)
      .pipe(
        concatMap(() =>
          this.http.get(
            `${environment.API_ENDPOINT}/payment/payable/${payableId}`,
          ),
        ),
      )
  }

  public deleteCompoundPayment({ id, payable }: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/payment/${id}`

    return this.http
      .delete(url)
      .pipe(
        concatMap(() =>
          this.http.get(
            `${environment.API_ENDPOINT}/payment/payable/${payable.id}`,
          ),
        ),
      )
  }

  public downloadCompoundPayment(payment: any): Observable<any> {
    let url = `${environment.API_ENDPOINT}/payment/receipt/${payment.id}`

    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }

  public fetchCompoundDocuments(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/compound/${id}/documents`
    return this.http.get(url, {})
  }

  public downloadCompoundDocument({
    compoundId,
    dataCycleId,
  }: any): Observable<any> {
    return this.http.get(
      `${environment.API_ENDPOINT}/compound/${compoundId}/downloadCL/${dataCycleId}`,
      {
        observe: 'response',
        responseType: 'blob' as 'json',
      },
    )
  }

  public generateCompoundDocument({ compoundId }: any): Observable<any> {
    return this.http.get(
      `${environment.API_ENDPOINT}/compound/${compoundId}/generateCL`,
    )
  }

  public deleteCompoundDocument({ compoundId }: any): Observable<any> {
    return this.http.get(
      `${environment.API_ENDPOINT}/compound/${compoundId}/deleteCurrentCL`,
    )
  }
}
